import SkuDeliveryModal from './SkuDeliveryModal.component'

export default SkuDeliveryModal
